module.exports = __webpack_public_path__ + "img/pay-success.0e23eb06.svg";